
const messages = {
    en: {
        files: {
            file: {
                selectFile: 'Select a file',
            }
        }
    },
    es: {
        files: {
            file: {
                selectFile: 'Seleccionar archivo',


            }
        }
    },
    pt: {
        files: {
            file: {
                selectFile: 'Select a file',

            }
        }
    }
}

export default messages